import request from '@/utils/request'
/* 获取发放计划列表-分页 */
export function getPlanPage(data) {
  return request({
    url: '/admin/plans/page',
    method: 'get',
		params:data
  })
}
/* 新增计划 */
export function addPlan(data) {
  return request({
    url: '/admin/plan',
    method: 'post',
    data,
  })
}
/* 编辑计划 */
export function editPlan(data) {
  return request({
    url: '/admin/plan/'+data.id,
    method: 'put',
    data,
  })
}
/* 删除部门 */
export function deletePlan(data) {
  return request({
    url: '/admin/plan/'+data.id,
    method: 'delete',
  })
}
/* 启动暂停计划 */
export function stopPlan(data) {
  return request({
    url: '/admin/plan/'+data.id+'/stop',
    method: 'put',
  })
}
/* 立即执行一次计划 */
export function executePlan(data) {
  return request({
    url: '/admin/plan/'+data.id+'/execute',
    method: 'put',
  })
}
/* 获取发放记录列表-分页 */
export function getRecordPage(data) {
  return request({
    url: '/admin/plan-records/page',
    method: 'get',
		params:data
  })
}
/* 获取发放记录详情 */
export function getRecordDetail(data) {
  return request({
    url: '/admin/plan-record/'+data.id,
    method: 'get',
  })
}
/* 统计账户 */
export function getAccountCount() {
  return request({
    url: '/admin/account/count',
    method: 'get',
  })
}
/* 根据时间统计 */
export function getAccountOrder(data) {
  return request({
    url: '/admin/account/count-order',
    method: 'get',
		params:data
  })
}
/* 集采订单统计 */
export function getOrderCount() {
  return request({
    url: '/admin/order/count',
    method: 'get',
  })
}
/* 集采订单分页列表 */
export function getOrderPage(data) {
  return request({
    url: '/admin/orders/page',
    method: 'get',
		params:data
  })
}

